// Fielding is over across the whole terminal band, not on `finished` alone — a refunded survey has
// stopped collecting too, and a survey under panel review reached that state by the same call that
// would otherwise have finished it. Reopening one for replacements moves it back out of review
// before a respondent can enter, so no response ever arrives under these statuses. A survey merely
// paused or on hold stopped short of its target and can resume collecting under the status it
// already has, which is why the band is not simply "not started". Keeping the band right is what
// stops the report claiming analysis is still running, or a share still provisional, while its
// sibling figures render a completed account.
const FIELDING_COMPLETE_STATUSES = ['finished', 'auto_refund', 'manual_refund', 'review']

export const fieldingComplete = surveyStatus => FIELDING_COMPLETE_STATUSES.includes(surveyStatus)
